<template>
  <div id="app">
    <h1>Current Insta Celebration Categories</h1>
    <v-app id="inspire">
      <v-container class="grey lighten-5">
        <v-row no-gutters>
          <template v-for="item in instaCheerCategories">
            <v-col :key="item.key">
              <v-card class="mx-auto" max-width="344">
                <v-img :src="item.imageUrl" height="200px"></v-img>

                <v-card-title>
                  {{ item.id }}
                </v-card-title>

                <v-card-actions>
                  <router-link
                    :to="{ name: 'About', params: { categoryId: item.id } }"
                    ><v-btn color="orange lighten-2" text>
                      Explore
                    </v-btn></router-link
                  >
                  <v-btn @click="deleteCategory(item.id)" outlined rounded text>
                    Delete
                  </v-btn>
                </v-card-actions>

                <v-spacer></v-spacer>
              </v-card>
            </v-col>
            <v-responsive
              v-if="item === 2"
              :key="`width-${item}`"
              width="100%"
            ></v-responsive>
          </template>
        </v-row>
      </v-container>

      <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="600px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark v-bind="attrs" v-on="on">
              Add Category
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Insta Celebration Category</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="categoryName"
                      label="Category Name"
                      required
                    ></v-text-field>
                    <div>
                      <v-btn @click="click1">choose a photo</v-btn>
                      <input
                        type="file"
                        ref="input1"
                        style="display: none"
                        @change="previewImage"
                        accept="image/*"
                      />
                    </div>

                    <div v-if="imageData != null">
                      <img
                        class="preview"
                        height="268"
                        width="356"
                        :src="img1"
                      />
                      <br />
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialog = false">
                Close
              </v-btn>
              <v-btn color="blue darken-1" text @click="addCategory()">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </v-app>
  </div>
</template>

<script>
export default {
  data() {
    return {
      instaCheerCategories: [],
      dialog: false,
      caption: "",
      img1: "",
      imageData: null,
      firebaseUrl: "",
      categoryName: ""
    };
  },
  methods: {
    async addCategory() {
      const db = this.$firebase.firestore();
      let obj = this;

      if (this.firebaseUrl && this.categoryName) {
        const data = {
          id: this.categoryName,
          imageUrl: this.firebaseUrl
        };

        // Add a new document in collection "cities" with ID 'LA'
        db.collection("insta_celebration_category")
          .doc(this.categoryName)
          .set(data)
          .then(function() {
            obj.dialog = false;
            console.log("done uploaded");
          })
          .catch(function(err) {
            console.log(err);
          });
      } else {
        console.log("Name and Image are needed");
      }
    },
    click1() {
      this.$refs.input1.click();
    },
    previewImage(event) {
      this.uploadValue = 0;
      this.img1 = null;
      this.imageData = event.target.files[0];
      this.onUpload();
    },
    onUpload() {
      this.img1 = null;
      const storageRef = this.$firebase
        .storage()
        .ref(`${this.imageData.name}`)
        .put(this.imageData);
      storageRef.on(
        `state_changed`,
        snapshot => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        error => {
          console.log(error.message);
        },
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then(url => {
            this.img1 = url;
            this.firebaseUrl = url;
            console.log(this.img1);
          });
        }
      );
    },
    async deleteCategory(id) {
      const db = this.$firebase.firestore();
      console.log(id);
      db.collection("insta_celebration_category")
        .doc(id)
        .delete()
        .then((this.dialog = false));
    }
  },
  mounted() {
    const db = this.$firebase.firestore();
    const doc = db.collection("insta_celebration_category");

    doc.onSnapshot(
      snap => {
        const instaCheerCategories = [];
        snap.forEach(doc => {
          instaCheerCategories.push(doc.data());
        });
        this.instaCheerCategories = instaCheerCategories;
      },
      err => {
        console.log(`Encountered error: ${err}`);
      }
    );
  }
};
</script>

<style></style>
